import { render, staticRenderFns } from "./titles.vue?vue&type=template&id=66fa7b33&scoped=true"
import script from "./titles.vue?vue&type=script&lang=js"
export * from "./titles.vue?vue&type=script&lang=js"
import style0 from "./titles.vue?vue&type=style&index=0&id=66fa7b33&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66fa7b33",
  null
  
)

export default component.exports